import React from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../features/common/Loader/Loader';
import TableHeader from '../data-tables/TableHeader';
import GlWidgetTable from './GlWidgetTable';
import { RootState } from '../../store';

interface GenericGlWidgetProps {
  title: string;
  rowsConfig: any[][];
  wellTestDetails?: boolean;
}

const GenericGlWidget: React.FC<GenericGlWidgetProps> = ({ title, rowsConfig, wellTestDetails = true }) => {
  const data = useSelector((state: RootState) => state.LatestAssetTrendData.data) || [];
  const wellInfo = (useSelector((state: RootState) => state.WellTestIdSlice.data) as Record<string, any>) || {};
  const isLoading = useSelector((state: RootState) => state.LatestAssetTrendData.loading);

  return (
    <main className='main-container table-wrap'>
      <TableHeader title={title} wellTestDetails={wellTestDetails} />
      {isLoading ? (
        <div className='flex justify-center items-center h-[70%]'>
          <Loader />
        </div>
      ) : data.length > 0 ? (
        <GlWidgetTable data={data} rowsConfig={rowsConfig} wellInfo={wellInfo} />
      ) : (
        <div className='flex justify-center items-center h-[70%]'>
          <span>No records found</span>
        </div>
      )}
    </main>
  );
};

export default GenericGlWidget;
